/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { Row, Col } from "@nordcloud/gnui";

const defaultSidebarWidth = {
  xs: 8,
  md: 2,
  lg: 2,
};

type SidebarWidth = {
  xs: number;
  md: number;
  lg: number;
};

type Props = {
  sidebarWidth?: SidebarWidth;
  sidebar: React.ReactNode;
  children: React.ReactNode;
};

export function SidebarLayout({
  sidebar,
  children,
  sidebarWidth = defaultSidebarWidth,
}: Props) {
  return (
    <Row>
      <Col xs={sidebarWidth.xs} md={sidebarWidth.md} lg={sidebarWidth.lg}>
        {sidebar}
      </Col>
      <Col
        xs={16 - sidebarWidth.xs}
        md={8 - sidebarWidth.md}
        lg={12 - sidebarWidth.lg}
      >
        {children}
      </Col>
    </Row>
  );
}
